import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    index: 0
  },
  mutations: {
    UPDATE_INDEX(state, newIndex) {
      state.index = newIndex;
    }
  },
  actions: {
    updateIndex({ commit }, newIndex) {
      commit('UPDATE_INDEX', newIndex);
    }
  }
});